<ng-template cignaIconDynamic></ng-template>
